export default __webpack_public_path__ + "static/media/jumga logo.81cfd8a2.png";